// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { StarFilledIcon, Typography } from '@iheartjane/reefer';

import { formatLargeNumber } from '@jane/shared/util';

import { useProductCardContext } from '../productCardProvider';
import { potencyInfo } from '../productPotency/productPotency';
import { ProductCategoryLabel } from './productCategoryLabel';

const TextDetailsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

const ReviewsContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const StyledFirstLine = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '16px',
});

interface TextDetailsProps {
  shouldDisplaySponsoredTag: boolean;
}

export const TextDetails = ({
  shouldDisplaySponsoredTag,
}: TextDetailsProps) => {
  const { menuProduct: product, selectedWeight } = useProductCardContext();

  const reviewCount =
    product && product.review_count && product.review_count > 999
      ? formatLargeNumber(product.review_count, 1)
      : product?.review_count;

  return (
    <>
      {product && (
        <TextDetailsContainer>
          <StyledFirstLine>
            <ProductCategoryLabel />
            {product.aggregate_rating ? (
              <ReviewsContainer>
                <StarFilledIcon color="gold" size="sm" mr={2} />
                <Typography
                  className="sparta"
                  maxLines={1}
                  variant="mini"
                  color="text-main"
                >
                  {product.aggregate_rating.toFixed(1)} ({reviewCount})
                </Typography>
              </ReviewsContainer>
            ) : null}
          </StyledFirstLine>
          {shouldDisplaySponsoredTag && (
            <Typography color="grays-mid" variant="mini">
              Sponsored
            </Typography>
          )}
          <Typography variant="body-bold">{product?.name}</Typography>
          <Typography>{product?.brand}</Typography>
          <Typography>{potencyInfo(product, selectedWeight)}</Typography>
        </TextDetailsContainer>
      )}
    </>
  );
};
